<div class="container-fluid" style="overflow: hidden;">





    <div class="card border-0 no-shadow mb-3  bg-white ">
        <div class="card-header text-white" style="background: #56A898;border-radius: 10px;">
            Onboard Container
        </div>
        <div class="card-body">
            <form [formGroup]="formQuestion" (ngSubmit)="onSubmit()">
                <div class="col-sm-12 col-md-10 col-lg-10">
                     <div class="row mt-2">


                        <h6 class="mb-3">Challan Details</h6>


                        <div class="col-lg-3 col-sm-6 col-md-4   ">



                            <div class="form-group ">


                                <input class="form-control " placeholder="Container Id" type="text" formControlName="id"
                                    [class.invalid]="!formQuestion.controls['id'].valid && formQuestion.controls['id'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['id'].valid && (formQuestion.controls['id'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter container id
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-4   ">

                            <div class="form-group ">

                                <input class="form-control" placeholder="Container Division" type="text"
                                    formControlName="division"
                                    [class.invalid]="!formQuestion.controls['division'].valid && formQuestion.controls['division'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['division'].valid && (formQuestion.controls['division'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter container
                                        division</div>
                                </div>

                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-4   ">

                            <div class="form-group ">

                                <input class="form-control" placeholder="Container Location" type="text"
                                    formControlName="location"
                                    [class.invalid]="!formQuestion.controls['location'].valid && formQuestion.controls['location'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['location'].valid && (formQuestion.controls['location'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter container
                                        location</div>
                                </div>

                            </div>
                        </div>
                    </div>
                     <div class="row mt-2">

                        <div class="col-lg-3 col-sm-6 col-md-4   ">

                            <div class="form-group ">
                                <input class="form-control" placeholder="Scale Number" type="text"
                                    formControlName="scale"
                                    [class.invalid]="!formQuestion.controls['scale'].valid && formQuestion.controls['scale'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['scale'].valid && (formQuestion.controls['scale'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter scale number
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-4   ">


                            <div class="form-group ">
                                <input class="form-control" placeholder="Division Challan Number" type="text"
                                    formControlName="divNumber"
                                    [class.invalid]="!formQuestion.controls['divNumber'].valid && formQuestion.controls['divNumber'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['divNumber'].valid && (formQuestion.controls['divNumber'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter division challan
                                        number
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-4   ">


                            <div class="form-group ">
                                <input class="form-control" placeholder="Factory Challan Number" type="text"
                                    formControlName="challanNumber"
                                    [class.invalid]="!formQuestion.controls['challanNumber'].valid && formQuestion.controls['challanNumber'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['challanNumber'].valid && (formQuestion.controls['challanNumber'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter challan number
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                     <div class="row mt-2">


                        <div class="col-lg-3 col-sm-6 col-md-4   ">


                            <div class="form-group ">
                                <input class="form-control" placeholder="Empty Container Weight" type="text"
                                    formControlName="weight"
                                    [class.invalid]="!formQuestion.controls['weight'].valid && formQuestion.controls['weight'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['weight'].valid && (formQuestion.controls['weight'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter Container Weight
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div class="col-lg-3 col-sm-6 col-md-4   ">


                            <div class="form-group ">
                                <input class="form-control" placeholder="Opium Weight" type="text"
                                    formControlName="opium"
                                    [class.invalid]="!formQuestion.controls['opium'].valid && formQuestion.controls['opium'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['opium'].valid && (formQuestion.controls['opium'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter Opium Weight
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div class="col-lg-3 col-sm-6 col-md-4   ">


                            <div class="form-group ">
                                <input class="form-control" placeholder="Container Year" type="text"
                                    formControlName="containerYear"
                                    [class.invalid]="!formQuestion.controls['containerYear'].valid && formQuestion.controls['containerYear'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['containerYear'].valid && (formQuestion.controls['containerYear'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter container year
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                     <div class="row mt-2">


                        <div class="col-lg-3 col-sm-6 col-md-4   ">


                            <div class="form-group ">
                                <input class="form-control" placeholder="Total Weight" type="text"
                                    formControlName="totalWeight"
                                    [class.invalid]="!formQuestion.controls['totalWeight'].valid && formQuestion.controls['totalWeight'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['totalWeight'].valid && (formQuestion.controls['totalWeight'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter total weight
                                    </div>
                                </div>
                                <!-- <div
                        *ngIf="!formUser.controls['firstName'].valid && (formUser.controls['firstName'].touched || isSubmitted)">
                        <div class="invalid-feedback" style="display: block;">Please enter first name</div>
                    </div> -->
                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-4   ">


                            <div class="form-group ">
                                <input class="form-control" placeholder="stage" type="text" formControlName="stage"
                                    [class.invalid]="!formQuestion.controls['stage'].valid && formQuestion.controls['stage'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['stage'].valid && (formQuestion.controls['stage'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter stage
                                    </div>
                                </div>
                                <!-- <div
                        *ngIf="!formUser.controls['firstName'].valid && (formUser.controls['firstName'].touched || isSubmitted)">
                        <div class="invalid-feedback" style="display: block;">Please enter first name</div>
                    </div> -->
                            </div>
                        </div>
                    </div>










                     <div class="row mt-2">


                        <h6 class="mb-3">Cultivator Details</h6>

                        <div class="col-lg-3 col-sm-6 col-md-4 ">


                            <div class="form-group ">


                                <input class="form-control " placeholder="Cultivator Name" type="text"
                                    formControlName="cultivator"
                                    [class.invalid]="!formQuestion.controls['cultivator'].valid && formQuestion.controls['cultivator'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['cultivator'].valid && (formQuestion.controls['cultivator'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter cultivator name
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-4   ">


                            <div class="form-group ">

                                <input class="form-control" placeholder="Father/Husband Name" type="text"
                                    formControlName="fatherName"
                                    [class.invalid]="!formQuestion.controls['fatherName'].valid && formQuestion.controls['fatherName'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['fatherName'].valid && (formQuestion.controls['fatherName'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter father/husband
                                        name</div>
                                </div>

                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-4   ">


                            <div class="form-group ">

                                <input class="form-control" placeholder="License Number" type="text"
                                    formControlName="license"
                                    [class.invalid]="!formQuestion.controls['license'].valid && formQuestion.controls['license'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['license'].valid && (formQuestion.controls['license'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter license number
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                     <div class="row mt-2">




                        <div class="col-lg-3 col-sm-6 col-md-4   ">


                            <div class="form-group ">
                                <input class="form-control" placeholder="Village Name" type="text"
                                    formControlName="village"
                                    [class.invalid]="!formQuestion.controls['village'].valid && formQuestion.controls['village'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['village'].valid && (formQuestion.controls['village'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter village name
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-4  ">


                            <div class="form-group ">
                                <input class="form-control" placeholder="Tehsil Name" type="text"
                                    formControlName="tehsil"
                                    [class.invalid]="!formQuestion.controls['tehsil'].valid && formQuestion.controls['tehsil'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['tehsil'].valid && (formQuestion.controls['tehsil'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter tehsil name
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-4   ">


                            <div class="form-group ">
                                <input class="form-control" placeholder="Weightment center name" type="text"
                                    formControlName="center"
                                    [class.invalid]="!formQuestion.controls['center'].valid && formQuestion.controls['center'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['center'].valid && (formQuestion.controls['center'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter name
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                     <div class="row mt-2">



                        <div class="col-lg-3 col-sm-6 col-md-4   ">


                            <div class="form-group ">
                                <input class="form-control" placeholder="Weightment Date" type="text"
                                    formControlName="weightDate"
                                    [class.invalid]="!formQuestion.controls['weightDate'].valid && formQuestion.controls['weightDate'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['weightDate'].valid && (formQuestion.controls['weightDate'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter date
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>



                     <div class="row mt-2">


                        <h6 class="mb-3">Sample Details</h6>
                        <!-- <div class="col-sm-10"> -->

                        <div class="col-lg-3 col-sm-6 col-md-4 ">


                            <div class="form-group ">


                                <input class="form-control " placeholder="Sample Packet Weight" type="text"
                                    formControlName="packet"
                                    [class.invalid]="!formQuestion.controls['packet'].valid && formQuestion.controls['packet'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['packet'].valid && (formQuestion.controls['packet'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter weight</div>
                                </div>

                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-4   ">


                            <div class="form-group ">

                                <input class="form-control" placeholder="Bag Number" type="text" formControlName="bag"
                                    [class.invalid]="!formQuestion.controls['bag'].valid && formQuestion.controls['bag'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['bag'].valid && (formQuestion.controls['bag'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter bag number</div>
                                </div>

                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-4   ">


                            <div class="form-group ">

                                <input class="form-control" placeholder="Opium Class" type="text"
                                    formControlName="class"
                                    [class.invalid]="!formQuestion.controls['class'].valid && formQuestion.controls['class'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['class'].valid && (formQuestion.controls['class'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter Opium Class</div>
                                </div>

                            </div>
                        </div>




                    </div>

                     <div class="row mt-2">


                        <h6 class="mb-3">Receiver Details</h6>
                        <!-- <div class="col-sm-10"> -->

                        <div class="col-lg-3 col-sm-6 col-md-4 ">


                            <div class="form-group ">


                                <input class="form-control " placeholder="Receiver Name" type="text"
                                    formControlName="reciever"
                                    [class.invalid]="!formQuestion.controls['reciever'].valid && formQuestion.controls['reciever'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['reciever'].valid && (formQuestion.controls['reciever'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter name</div>
                                </div>
                                <!-- <div
                        *ngIf="!formUser.controls['firstName'].valid && (formUser.controls['firstName'].touched || isSubmitted)">
                        <div class="invalid-feedback" style="display: block;">Please enter first name</div>
                    </div> -->
                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-4 ">


                            <div class="form-group ">

                                <input class="form-control" placeholder="Receiving Time" type="text"
                                    formControlName="recieverTime"
                                    [class.invalid]="!formQuestion.controls['recieverTime'].valid && formQuestion.controls['recieverTime'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['recieverTime'].valid && (formQuestion.controls['recieverTime'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter time</div>
                                </div>
                                <!-- <div
                        *ngIf="!formUser.controls['firstName'].valid && (formUser.controls['firstName'].touched || isSubmitted)">
                        <div class="invalid-feedback" style="display: block;">Please enter first name</div>
                    </div> -->
                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-6 col-md-4   ">


                            <div class="form-group ">

                                <input class="form-control" placeholder="Receiving Date" type="text"
                                    formControlName="recieverDate"
                                    [class.invalid]="!formQuestion.controls['recieverDate'].valid && formQuestion.controls['recieverDate'].touched">
                                <div
                                    *ngIf="!formQuestion.controls['recieverDate'].valid && (formQuestion.controls['recieverDate'].touched || isSubmitted)">
                                    <div class="invalid-feedback" style="display: block;">Please enter date</div>
                                </div>
                                <!-- <div
                        *ngIf="!formUser.controls['firstName'].valid && (formUser.controls['firstName'].touched || isSubmitted)">
                        <div class="invalid-feedback" style="display: block;">Please enter first name</div>
                    </div> -->
                            </div>
                        </div>




                    </div>


                    <div class="form-row mt-3">

                        <div class="form-group col-sm-12 col-md-10 col-lg-10">

                            <div class="text-center m-3 mb-5">
                                <button class="btn" (click)="onSubmit()">Submit</button>
                                <!-- <button class="btn  ">Cancel</button> -->


                            </div>
                        </div>
                    </div>





                </div>

            </form>




        </div>

    </div>


</div>